import { InjectionToken } from '@angular/core';

export const basePath = new InjectionToken('basePath');
export const filePath = new InjectionToken('filePath');
export const productionMode = new InjectionToken('productionMode');
export const pdfPlaceholderPath = new InjectionToken('pdfPlaceholderPath');
export const appVersion = new InjectionToken('appVersion');
